import { render } from "./view-detail-invoice.vue?vue&type=template&id=518d9487&ts=true"
import script from "./view-detail-invoice.vue?vue&type=script&lang=ts"
export * from "./view-detail-invoice.vue?vue&type=script&lang=ts"

import "./view-detail-invoice.vue?vue&type=style&index=0&id=518d9487&lang=scss"

import exportComponent from "/codebuild/output/src3714422101/src/github.com/teknologi-kartu/crm-web-admin-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__